// @file based on the 'data-bridged-link', it adds a click listener that will intercept clicks on anchor tags
// and pass the appropriate content category and content subcategory to the native app

import { ActionableStore } from 'native_bridge/types'

export const BRIDGED_LINK_TYPE_ATTRIBUTE = 'data-bridged-link'

export const createClickListener = (store: ActionableStore): ((e: Event) => void) => {
  return (e: Event): void => {
    const clickTarget = e.target as HTMLElement
    // only process anchor tags
    const target = clickTarget.closest('a')
    if (target == null) return
    // only process anchor tags with our special class
    if (target.hasAttribute(BRIDGED_LINK_TYPE_ATTRIBUTE)) {
      const anchorHref = target.getAttribute('href')
      const anchorTarget = target.getAttribute('target')
      const linkType = target.getAttribute(BRIDGED_LINK_TYPE_ATTRIBUTE)
      e.preventDefault()
      const openLinkPayload: Record<string, any> = {
        linkType,
        target: anchorTarget,
        url: anchorHref,
      }

      switch (linkType) {
        case 'padlet':
          openLinkPayload.contentCategory = 'page'
          openLinkPayload.contentSubcategory = 'padlet'
          break
        case 'slideshow':
          openLinkPayload.contentCategory = 'page'
          openLinkPayload.contentSubcategory = 'slideshow'
          break
        case 'profile':
          openLinkPayload.contentCategory = 'page'
          openLinkPayload.contentSubcategory = 'profile'
          openLinkPayload.username = target.getAttribute('data-bridged-link-username')
          break
      }
      store.dispatch('nativeApp/openLink', openLinkPayload)
    }
  }
}
